export const calculateBMI = (weight, height) => {
  return Math.round((weight / height ** 2) * 100000) / 10
}
